import { IFormFieldKeyLookupManage } from "../_common/models/formFieldKeyLookup";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "formFieldKeyLookup";

export const formFieldKeyLookupService = {
    get,
    getAll,
    post,
    put,
    disable,
    dropdown,
    submit(model?: IFormFieldKeyLookupManage) { return model?.id ? put(model) : post(model) }
};

function get(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/get/?id=${id}`, requestOptions).then(handleResponse);
}

function getAll(formFieldKeyId: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAll/?formFieldKeyId=${formFieldKeyId}`, requestOptions).then(handleResponse);
}

function post(model?: IFormFieldKeyLookupManage) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}

function put(model?: IFormFieldKeyLookupManage) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}

function disable(id: number) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/${id}`, requestOptions).then(handleResponse);
}

function dropdown(formTemplateSectionId: number) {
    const requestOptions = { method: 'Get', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/dropdown/?formTemplateSectionId=${formTemplateSectionId}`, requestOptions).then(handleResponse);
}
